<template>
  <v-container>
    <div id="headersFornedores">
      <div
        v-if="loading"
        :style="styleObject"
        class="text-center"
      >
        <v-icon
          light
          class="custom-loader"
          :style="styleObject"
        >
          mdi-cached
        </v-icon>
        Carregando dados...
      </div>
      <div
        v-else-if="error"
        class="alert alert-danger"
      >
        {{ error }}
      </div>
      <div
        v-else
      >
        <br><br>
        <div>
          <v-btn
            id="btnPrint"
            class="cols-12 sm-3 md-3 lg-1"
            small
            dark
            :disabled="enableBtn"
            :color="corPrimaria"
            :loading="imprimindo"
            @click="exportExcel()"
          >
            <v-icon>
              mdi-printer
            </v-icon>
            Exporta Excel
            <template v-slot:loader>
              <span>Gerando...</span>
            </template>
          </v-btn>
        </div>
        <br>
        <div
          id="idTable"
          style="overflow-x: auto;"
        >
          <table
            style="width: 100%; color: black; border-collapse: collapse;"
            class="elevation-1"
          >
            <thead>
              <tr>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                >
                  Linhas Produção
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                >
                  % P1
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                >
                  Faturamento P1
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                >
                  V%
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                >
                  % P2
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                >
                  Faturamento P2
                </th>
              </tr>
            </thead>
            <tbody
              v-for="item in dadosFaturamento"
              :key="item.id"
            >
              <tr>
                <td
                  id="dadoMovimentacao"
                  style="text-align: left;"
                >
                  {{ item.linhas }}
                </td>
                <td
                  id="dadoMovimentacao"
                  class="text-right"
                  :style="styleObject1"
                >
                  {{ item.porcentagem1 }}
                </td>
                <td
                  id="dadoMovimentacao"
                  class="text-right"
                  :style="styleObject1"
                >
                  {{ item.valor1 }}
                </td>
                <td
                  id="dadoMovimentacao"
                  class="text-right"
                  :style="getColor(item.variacao)"
                >
                  {{ item.variacaoExibicao }}
                </td>
                <td
                  id="dadoMovimentacao"
                  class="text-right"
                  :style="styleObject2"
                >
                  {{ item.porcentagem2 }}
                </td>
                <td
                  id="dadoMovimentacao"
                  class="text-right"
                  :style="styleObject2"
                >
                  {{ item.valor2 }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
  import LinhaProducao from '../../../../services/linhaproducao'
  import eventEmit from '../core/EventoEmit'
  import ExcelJS from 'exceljs'
  import { saveAs } from 'file-saver'

  export default {
    name: 'ShowDadosComparativoFaturamento',
    emits: ['setDadosComparativoFaturamento'],
    components: {
    },
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      styleObject1: {
        color: '#1B5E20',
      },
      styleObject2: {
        color: '#F57F17',
      },
      loading: false,
      error: null,
      dataInicial: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      dataFinal: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      empresaSelect: [],
      cidades: [],
      redes: [],
      areas: [],
      vendedores: [],
      clientes: [],
      produtos: [],
      linhas: [],
      dataInicial1: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      dataFinal1: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      empresaSelect1: [],
      cidades1: [],
      redes1: [],
      areas1: [],
      vendedores1: [],
      clientes1: [],
      produtos1: [],
      linhas1: [],
      segmento: [],
      segmento1: [],
      headersFaturamentoxLinha: [
        { text: 'Linhas Produção', value: 'linhas', align: 'left', class: 'black--text title' },
        { text: '%', value: 'porcentagem1', align: 'right', class: 'black--text title' },
        { text: 'Faturamento P1', value: 'valor1', align: 'right', class: 'black--text title' },
        { text: 'V%', value: 'variacao', align: 'right', class: 'black--text title' },
        { text: '%', value: 'porcentagem2', align: 'right', class: 'black--text title' },
        { text: 'Faturamento P2', value: 'valor2', align: 'right', class: 'black--text title' },
      ],
      headersFaturamentoxLinhaMobile: [
        { text: 'Linhas Produção', value: 'linhas', align: 'left', class: 'black--text title' },
        { text: '% P1', value: 'porcentagem1', align: 'right', class: 'black--text title' },
        { text: 'Faturamento P1', value: 'valor1', align: 'right', class: 'black--text title' },
        { text: 'V%', value: 'variacao', align: 'right', class: 'black--text title' },
        { text: '% P2', value: 'porcentagem2', align: 'right', class: 'black--text title' },
        { text: 'Faturamento P2', value: 'valor2', align: 'right', class: 'black--text title' },
      ],
      dadosFaturamento: [],
      isMobile: true,
      enableBtn: true,
      imprimindo: false,
      corPrimaria: localStorage.corPrimaria,
    }),

    created () {
      eventEmit.$on('update-form-mais-vida', this.handleUpdateDados)

      this.isMobile = (window.innerWidth <= 768) ? null : true // Ajuste conforme necessário
    },

    beforeDestroy () {
      eventEmit.$off('update-form-mais-vida', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (dataInicial, dataFinal, empresaSelect, cidadeSelect, areaSelect, vendedorSelect, redeSelect, produtoSelect, linhaSelect, clienteSelect, dataInicial1, dataFinal1, empresaSelect1, cidadeSelect1, areaSelect1, vendedorSelect1, redeSelect1, produtoSelect1, linhaSelect1, clienteSelect1, segmento, segmento1) {
        this.dataInicial = dataInicial
        this.dataFinal = dataFinal
        this.empresaSelect = empresaSelect
        this.cidades = cidadeSelect
        this.areas = areaSelect
        this.vendedores = vendedorSelect
        this.redes = redeSelect
        this.produtos = produtoSelect
        this.linhas = linhaSelect
        this.clientes = clienteSelect
        this.dataInicial1 = dataInicial1
        this.dataFinal1 = dataFinal1
        this.empresaSelect1 = empresaSelect1
        this.cidades1 = cidadeSelect1
        this.areas1 = areaSelect1
        this.vendedores1 = vendedorSelect1
        this.redes1 = redeSelect1
        this.produtos1 = produtoSelect1
        this.linhas1 = linhaSelect1
        this.clientes1 = clienteSelect1
        this.segmento = segmento
        this.segmento1 = segmento1

        this.atualizaDados()
      },

      async atualizaDados () {
        this.loading = true
        this.dadosFaturamento = []
        this.enableBtn = true

        await LinhaProducao.showComparativoFaturamento(this.dataInicial, this.dataFinal, this.empresaSelect, this.cidades, this.areas, this.vendedores, this.redes, localStorage.tokencontrato, this.dataInicial1, this.dataFinal1, this.empresaSelect1, this.cidades1, this.areas1, this.vendedores1, this.redes1, this.segmento, this.segmento1).then(resposta => {
          if (resposta.data.status) {
            this.enableBtn = false

            this.dadosFaturamento = resposta.data.dadosFaturamento.map((item) => {
              var listaDadosFaturamento = ({
                linhas: item.linhas,
                porcentagem1: item.porcentagem1 + '%',
                valor1: parseFloat(item.valor1).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                variacao: item.variacao,
                variacaoExibicao: item.variacao ? item.variacao.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%' : '-',
                porcentagem2: item.porcentagem2 + '%',
                valor2: parseFloat(item.valor2).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
              })

              return listaDadosFaturamento
            })

            eventEmit.$emit('set-dados-comparativo-faturamento', this.dadosFaturamento)
          } else if (resposta.data.msg === 'Não dados de valores a pagar para fornecedores no período selecionado') {
            this.dadosFaturamento = []

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading = false })
      },

      getColor (value) {
        if (value < 0) {
          return 'color: #C62828'
        } else if (value > 0) {
          return 'color: #2196F3'
        } else {
          return 'color: #000000'
        }
      },

      async exportExcel () {
        try {
          this.imprimindo = true

          await setTimeout(() => {
            this.printExcel()
          }, 2000)
        } catch (error) {
          console.error('Erro ao exportar excel', error)
        }
      },

      async printExcel () {
        try {
          const workbook = new ExcelJS.Workbook()
          const worksheet = workbook.addWorksheet('Relatório Comparativo Faturamento')

          let posY = 1

          const inserirTitulo = (worksheet) => {
            // Adicionar Título
            worksheet.mergeCells(`A${posY}:F${posY}`)
            worksheet.getCell(`A${posY}`).value = 'Filtros selecionados'
            worksheet.getCell(`A${posY}`).font = { size: 14, bold: true }
            worksheet.getCell(`A${posY}`).alignment = { vertical: 'middle', horizontal: 'left' }

            posY += 2

            // Adicionar Período
            worksheet.mergeCells(`A${posY}:C${posY}`)
            worksheet.getCell(`A${posY}`).value = 'Período 1'
            worksheet.getCell(`A${posY}`).font = { size: 14, bold: true }
            worksheet.getCell(`A${posY}`).alignment = { vertical: 'middle', horizontal: 'left' }
            // Adicionar Período
            worksheet.mergeCells(`D${posY}:F${posY}`)
            worksheet.getCell(`D${posY}`).value = 'Período 2'
            worksheet.getCell(`D${posY}`).font = { size: 14, bold: true }
            worksheet.getCell(`D${posY}`).alignment = { vertical: 'middle', horizontal: 'left' }

            posY += 2

            const dataInicial = this.dataInicial.substr(8) + '/' + this.dataInicial.substr(5, 2) + '/' + this.dataInicial.substr(0, 4)
            const ultimoDia = this.dataFinal.substr(8) + '/' + this.dataFinal.substr(5, 2) + '/' + this.dataFinal.substr(0, 4)
            worksheet.mergeCells(`A${posY}:C${posY}`)
            worksheet.getCell(`A${posY}`).value = `Data inicial: ${dataInicial} - Data final: ${ultimoDia}`
            worksheet.getCell(`A${posY}`).font = { size: 10 }
            worksheet.getCell(`A${posY}`).alignment = { vertical: 'middle', horizontal: 'left' }

            const dataInicial2 = this.dataInicial1.substr(8) + '/' + this.dataInicial1.substr(5, 2) + '/' + this.dataInicial1.substr(0, 4)
            const ultimoDia2 = this.dataFinal1.substr(8) + '/' + this.dataFinal1.substr(5, 2) + '/' + this.dataFinal1.substr(0, 4)
            worksheet.mergeCells(`D${posY}:F${posY}`)
            worksheet.getCell(`D${posY}`).value = `Data inicial: ${dataInicial2} - Data final: ${ultimoDia2}`
            worksheet.getCell(`D${posY}`).font = { size: 10 }
            worksheet.getCell(`D${posY}`).alignment = { vertical: 'middle', horizontal: 'left' }

            posY += 2

            const adicionarFiltros = (worksheet, posY, titulo, dados) => {
              if (dados.length > 0) {
                const texto = titulo + ' ' + dados.join(', ')

                worksheet.mergeCells(`A${posY}:C${posY}`)
                worksheet.getCell(`A${posY}`).value = texto
                worksheet.getCell(`A${posY}`).font = { size: 10 }
                worksheet.getCell(`A${posY}`).alignment = { vertical: 'middle', horizontal: 'left' }

                return posY + 1
              }
              return posY
            }

            const adicionarFiltros2 = (worksheet, posY, titulo, dados) => {
              if (dados.length > 0) {
                const texto = titulo + ' ' + dados.join(', ')

                worksheet.mergeCells(`D${posY}:F${posY}`)
                worksheet.getCell(`D${posY}`).value = texto
                worksheet.getCell(`D${posY}`).font = { size: 10 }
                worksheet.getCell(`D${posY}`).alignment = { vertical: 'middle', horizontal: 'left' }

                return posY + 1
              }
              return posY
            }

            posY = adicionarFiltros(worksheet, posY, 'Empresa(s) Selecionada(s):', this.empresaSelect.map(e => e.empresaSelect))
            posY = adicionarFiltros(worksheet, posY, 'Cidade(s) Selecionada(s):', this.cidades.map(e => e.cidade))
            posY = adicionarFiltros(worksheet, posY, 'Área(s) Selecionada(s):', this.areas.map(a => a.area))
            posY = adicionarFiltros(worksheet, posY, 'Rede(s) Selecionada(s):', this.redes.map(r => r.rede))
            posY = adicionarFiltros(worksheet, posY, 'Vendedor(es) Selecionado(s):', this.vendedores.map(v => v.vendedor))
            posY = adicionarFiltros(worksheet, posY, 'Segmento(s) Selecionado(s):', this.segmento.map(se => se.segmento))

            posY = adicionarFiltros2(worksheet, posY, 'Empresa(s) Selecionada(s):', this.empresaSelect1.map(e => e.empresaSelect))
            posY = adicionarFiltros2(worksheet, posY, 'Cidade(s) Selecionada(s):', this.cidades1.map(e => e.cidade))
            posY = adicionarFiltros2(worksheet, posY, 'Área(s) Selecionada(s):', this.areas1.map(a => a.area))
            posY = adicionarFiltros2(worksheet, posY, 'Rede(s) Selecionada(s):', this.redes1.map(r => r.rede))
            posY = adicionarFiltros2(worksheet, posY, 'Vendedor(es) Selecionado(s):', this.vendedores1.map(v => v.vendedor))
            posY = adicionarFiltros2(worksheet, posY, 'Segmento(s) Selecionado(s):', this.segmento1.map(se => se.segmento))

            posY += 1
          }

          posY += 1

          const ajustarLarguraColunas = (worksheet, headers, tableData) => {
            headers.forEach((header, i) => {
              let maxColumnWidth = header.length
              tableData.forEach(row => {
                const columnText = row[i] ? row[i].toString() : ''
                maxColumnWidth = Math.max(maxColumnWidth, columnText.length)
              })
              worksheet.getColumn(i + 1).width = maxColumnWidth + 2 // +2 para dar um pequeno espaçamento
            })
          }

          inserirTitulo(worksheet)

          // Adiciona tabela de dados
          const tableHeaders = this.headersFaturamentoxLinha.map(header => header.text)
          const tableData = this.dadosFaturamento.map(item => [
            item.linhas,
            item.porcentagem1,
            item.valor1,
            item.variacao ? item.variacao.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%' : '-',
            item.porcentagem2,
            item.valor2,
          ])

          worksheet.addRow(tableHeaders).font = { bold: true }
          tableData.forEach(row => worksheet.addRow(row))
          posY += tableData.length + 1

          ajustarLarguraColunas(worksheet, tableHeaders, tableData)

          const buffer = await workbook.xlsx.writeBuffer()
          saveAs(new Blob([buffer]), 'relatorio_comparativo_faturamento.xlsx')
        } catch (error) {
          console.error('Erro ao gerar Excel:', error)
        } finally {
          this.imprimindo = false
        }
      },
    },
  }
</script>

<style scoped>
  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #idTable {
      max-height: 500px;
      max-width: 370px !important;
      margin: 0 0 0 -1rem
    }

    #dadoMovimentacao {
      font-size: 8.5px;
    }

    th, td {
      padding: 8px;
    }
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {

  }

  @media screen
  and (min-width: 1601px) {
    #text1 {
      margin: 0 0 0 76rem !important;
    }

    #text2 {
      margin: 0 0 0 15.5rem !important;
    }
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 500px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }

  #text1 {
    margin: 0 0 0 47rem;
  }

  #text2 {
    margin: 0 0 0 11.5rem;
  }
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }
</style>
